<template>
	<div class="official-recommend-page">
		<div class="content-container">
			<div class="filterBox">
				<div class="searchBox">
					<input type="text" v-model="keywords" placeholder="请输入要寻找的作品名称" />
					<div class="search" @click="goodsHuaList">搜索</div>
					<input ref="imageSearchInput" class="imageSearchInput" type="file" accept="image/*"
						@change="onImageSearchFileChange" />
					<div class="imageSearch" :class="{ loading: imageSearchLoading }" @click="triggerImageSearch">
						{{ imageSearchLoading ? '识别中' : '以图搜图' }}
					</div>
				</div>
				<div class="filterTitle">作品筛选</div>
				<div class="filterItem">
					<div class="filterItemTitle">类型：</div>
					<div class="filterItemList">
						<div class="tip" :class="cid == '' ? 'active' : ''" @click="changeFilter('cid','')">全部</div>
						<div class="tip" :class="cid == item.id ? 'active' : ''" v-for="(item,index) in typeOpts"
							:key="index" @click="changeFilter('cid',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">用途：</div>
					<div class="filterItemList">
						<div class="tip" :class="yongtu == '' ? 'active' : ''" @click="changeFilter('yongtu','')">全部
						</div>
						<div class="tip" :class="yongtu == item.id ? 'active' : ''" v-for="(item,index) in yongtuOpts"
							:key="index" @click="changeFilter('yongtu',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">可购身份：</div>
					<div class="filterItemList">
						<div class="tip" :class="level == '' ? 'active' : ''" @click="changeFilter('level','')">全部</div>
						<div class="tip" :class="level == item.id ? 'active' : ''" v-for="(item,index) in levelOpts"
							:key="index" @click="changeFilter('level',item.id)">{{item.title}}</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">图片属性：</div>
					<div class="filterItemList">
						<div class="tip" :class="shuxing == item.title ? 'active' : ''"
							v-for="(item,index) in imgAttributeOpts" :key="index"
							@click="changeFilter('shuxing',item.title)">
							{{item.title}}
						</div>
					</div>
				</div>
				<div class="filterItem">
					<div class="filterItemTitle">排列方式：</div>
					<div class="filterItemList">
						<div class="tip" :class="px == item.value ? 'active' : ''" v-for="(item,index) in sortOpts"
							:key="index" @click="changeFilter('px',item.value)">{{item.title}}</div>
					</div>
				</div>
			</div>
			<div class="officialList">
				<OfficalItem class="officalItem" :routerType='1' :data="item" :showBuy="true" v-for="(item,index) in data" :key="index">
				</OfficalItem>
			</div>

			<!-- 分页控件 -->
			<PagePagination :currentPage="currentPage" :pageSize="12" :total="total" @current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import OfficalItem from '../components/OfficalItem.vue'
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'CreatorFlowerMarket',
		components: {
			OfficalItem,
			PagePagination
		},
		data() {
			return {
				data: [],
				keywords: '', //关键词
				shuxing: '默认',
				imgAttributeOpts: [{
					title: '默认',
					value: '0'
				}, {
					title: '精品图',
					value: '1'
				}, {
					title: '普通图',
					value: '2'
				}],
				px: '',
				sortOpts: [{
					title: '默认',
					value: ''
				}, {
					title: '最新发布',
					value: '1'
				}, {
					title: '最多点赞',
					value: '2'
				}, {
					title: '价格升序',
					value: '3'
				}, {
					title: '价格降序',
					value: '4'
				}], // {title: '综合排序',value: '5'}
				cid: '', //分类
				typeOpts: [],
				yongtu: '', //用途
				yongtuOpts: [],
				level: '',
				levelOpts: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				imageSearchLoading: false,
				imageSearchMode: false,
				artworks: [{
						id: 1,
						title: '山水意境',
						artist: '东方水墨',
						image: 'https://picsum.photos/id/1/600/400',
						views: 3200,
						likes: 850
					},
					{
						id: 2,
						title: '深海传说',
						artist: '海洋之心',
						image: 'https://picsum.photos/id/137/600/400',
						views: 2800,
						likes: 780
					},
					{
						id: 3,
						title: '都市肖像',
						artist: '城市之光',
						image: 'https://picsum.photos/id/1015/600/400',
						views: 4100,
						likes: 920
					},
					{
						id: 4,
						title: '自然奇观',
						artist: '山水之间',
						image: 'https://picsum.photos/id/1024/600/400',
						views: 3500,
						likes: 890
					},
					{
						id: 5,
						title: '古韵今风',
						artist: '建筑大师',
						image: 'https://picsum.photos/id/1043/600/400',
						views: 2900,
						likes: 750
					},
					{
						id: 6,
						title: '未来城市',
						artist: '科技先锋',
						image: 'https://picsum.photos/id/1067/600/400',
						views: 3800,
						likes: 910
					}
				]
			}
		},
		mounted() {
			if (this.$route.query.keywords) {
				this.keywords = this.$route.query.keywords
				this.$router.replace({
					query: {}
				});
			}
			this.goodsHuaList()
			this.basicsVipList()
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		methods: {
			// 页码变化处理
			onPageChange(newPage) {
				if (this.imageSearchMode) return
				this.currentPage = newPage
				this.goodsHuaList()
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsVipList() {
				this.$api.post('/Basics/vip_list', {}).then(res => {
					if (res.code == 1) {
						this.levelOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			triggerImageSearch() {
				if (this.imageSearchLoading) return
				if (this.$refs.imageSearchInput) {
					this.$refs.imageSearchInput.click()
				}
			},
			onImageSearchFileChange(event) {
				const file = event.target.files && event.target.files[0]
				event.target.value = ''
				if (!file) return
				this.searchByImage(file)
			},
			searchByImage(file) {
				this.imageSearchLoading = true
				const formData = new FormData()
				formData.append('file', file)
				formData.append('top_k', '12')
				axios.post('https://xieke.cc/api/materials/search_image', formData).then(res => {
					const body = res.data || {}
					if (body.code !== 200) {
						throw new Error(body.msg || '以图搜图失败')
					}
					const list = body.data && body.data.materials ? body.data.materials : []
					this.currentPage = 1
					this.imageSearchMode = true
					this.data = list.map(item => this.normalizeVisualMaterial(item))
					this.total = this.data.length
					this.$message.success(`以图搜图完成，找到 ${this.total} 个相似结果`)
				}).catch(err => {
					console.log(err)
					this.$message.error((err && err.message) || '以图搜图失败，请稍后再试')
				}).finally(() => {
					this.imageSearchLoading = false
				})
			},
			parseMaterialTags(tags) {
				const result = {}
				if (!tags || typeof tags !== 'string') return result
				tags.split(';').forEach(part => {
					const index = part.indexOf(':')
					if (index > 0) {
						result[part.slice(0, index)] = part.slice(index + 1)
					}
				})
				return result
			},
			normalizeVisualMaterial(item) {
				const tags = this.parseMaterialTags(item.tags)
				const goodsId = tags.old_gz_goods_id || tags.old_goods_id || item.goods_id || item.old_goods_id || item.id
				const imageUrl = item.thumb_url || item.preview_url || item.img || item.image || ''
				const price = item.cost_points !== undefined ? item.cost_points : (tags.old_buy_price || item.price || 0)
				return {
					...item,
					id: goodsId,
					material_id: item.id,
					user_id: item.user_id || 0,
					img: imageUrl,
					title: item.title || item.name || '',
					content: item.type_label || item.category || '以图搜图结果',
					cid: item.type_label || item.category || '',
					yongtu: [item.category || item.type_group || ''],
					price,
					zan_count: item.zan_count || 0,
				}
			},
			goodsHuaList() {
				this.imageSearchMode = false
				let params = {
					p: this.currentPage,
					title: this.title,
					label: this.type
				}
				if (this.active) {
					params[this.active] = 1
				}
				this.$api.post('/Goods/hua_list', {
					cid: this.cid,
					yongtu: this.yongtu,
					level: this.level,
					shuxing: this.shuxing == '默认' ? '' : this.shuxing,
					px: this.px,
					p: this.currentPage,
					top: this.keywords,
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data.all_list
						this.total = res.data.all_count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeFilter(type, value) {
				if (type == 'cid') {
					this.cid = value
				} else if (type == 'yongtu') {
					this.yongtu = value
				} else if (type == 'level') {
					this.level = value
				} else if (type == 'shuxing') {
					this.shuxing = value
				} else if (type == 'px') {
					this.px = value
				}
				this.goodsHuaList()
			},
		}
	}
</script>

<style lang="scss" scoped>
	.official-recommend-page {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	.filterBox {
		margin-top: .48rem;
		display: flex;
		flex-direction: column;
		width: 12rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		padding: 0 0 .24rem .32rem;

		.searchBox {
			margin: .24rem auto;
			display: flex;
			align-items: center;
			border-radius: .06rem;
			border: 0.01rem solid #E29358;
			width: 7.1rem;
			height: .4rem;
			overflow: hidden;

			input {
				flex: 1;
				min-width: 0;
				width: auto;
				height: .38rem;
				margin-left: .12rem;
				padding: 0 0;
				border: none;
				font-weight: 400;
				font-size: .14rem;
			}

			.search {
				width: .88rem;
				height: .4rem;
				background: #E29358;
				box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
				border-radius: 0 .06rem .06rem 0;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
				cursor: pointer;
			}

			.imageSearchInput {
				display: none;
			}

			.imageSearch {
				width: .98rem;
				height: .4rem;
				background: #98E83E;
				font-weight: 500;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
				cursor: pointer;
				white-space: nowrap;

				&.loading {
					opacity: .72;
					cursor: wait;
				}
			}
		}

		.filterTitle {
			font-weight: 500;
			font-size: .14rem;
			color: #000000;
		}

		.filterItem {
			display: flex;
			font-size: .14rem;

			.filterItemTitle {
				margin-top: .16rem;
				height: .28rem;
				line-height: .28rem;
				width: .75rem;
				font-weight: 400;
				color: #000000;
			}

			.filterItemList {
				width: calc(100% - .75rem);
				display: flex;
				flex-wrap: wrap;

				.tip {
					margin-top: .16rem;
					margin-right: .24rem;
					height: .28rem;
					line-height: .28rem;
					font-weight: 400;
					color: #666666;
					cursor: pointer;

					&.active {
						color: #000000;
						padding: 0 .1rem;
						background: #E29358;
						box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
						border-radius: .06rem;
					}
				}
			}
		}
	}

	.officialList {
		width: 12rem;
		display: flex;
		flex-wrap: wrap;

		.officalItem:nth-child(4n) {
			margin-right: 0;
		}
	}
</style>
